import { css, html } from 'react-strict-dom';
import { Color, Style } from 'src/constants';
import { Model } from 'src/models';
import { formatTimeSpent } from 'src/util';

import GoalRing from './GoalRing';
import Text from './Text';

const RING_SIZE = 36;
const RING_THICKNESS = 4;

type Props = {
  minutes: number;
};

/**
 * How the day is going against the logging goal.
 */
export default function TimerDailyGoal({ minutes }: Props) {
  const remaining = Model.DailyTask.getGoalRemaining(minutes);

  return (
    <html.div style={[Style.row, Style.alignCenter, styles.goal]}>
      <GoalRing
        progress={Model.DailyTask.getGoalProgress(minutes)}
        size={RING_SIZE}
        thickness={RING_THICKNESS}
        trackColor={Color.neutral10}
      />
      <html.div style={Style.col}>
        <Text typeface="body.small.medium" color="neutral100">
          {`${formatTimeSpent(minutes) ?? '0m'} today`}
        </Text>
        {remaining > 0 && (
          <Text typeface="caption.medium" color="neutral60">
            {`${formatTimeSpent(remaining)} to go`}
          </Text>
        )}
      </html.div>
    </html.div>
  );
}

const styles = css.create({
  goal: {
    gap: 10,
  },
});
